module.exports = __webpack_public_path__ + "static/no-image-0796b450f760e5ff96d2fe055a5173a0.png";